import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { icon } from "leaflet";
import { MapContainer, Marker, Popup, TileLayer, Tooltip } from "react-leaflet";
import { Select } from "antd";
import { AppContext } from "../../../Context/Context";
import Button from "../../Reusables/Button/Button";
import SiteSelectionPopup from "./SiteSelectionPopup";
import useModalClose from "../../../hooks/useModalClose";
import { reloadApp } from "../../../util/helper/helperFunctions";
import closeBtn from "../../../assets/icons/close.png";
import locationIcon from "../../../assets/icons/location.png";
import locationMarker from "../../../assets/icons/locationMarker.svg";
import activeLocationMarker from "../../../assets/icons/activeLocationMarker.svg";
import "../../../assets/css/MapModal/mapModal.css";

const MODAL_ID = "map-modal-wrapper-id";

const MapModal = () => {
  const { plantCode } = useParams();
  const navigate = useNavigate();
  const siteSelectionMap = useRef(null);
  const { setSiteSelectionModal, locationsData, setLocationCode } =
    useContext(AppContext);

  const [markers, setMarkers] = useState([]);
  const [locationsWithLatLng, setLocationsWithLatLng] = useState([]);

  useEffect(() => {
    document.body.classList.add("prevent-scroll");
    const data = locationsData?.map(({ latitude, longitude, ...rest }) => ({
      position: {
        lat: latitude,
        lng: longitude
      },
      ...rest
    }));
    setLocationsWithLatLng(data);
  }, [locationsData]);

  const addMarker = (e) => {
    let existingMarkers = markers;
    markers.push(e.latlng);
    setMarkers(existingMarkers);
  };

  const getLocationPlaceholder =
    plantCode && plantCode.length !== 0 ? plantCode : "Select Location";

  const closeModalWrapper = () => {
    setSiteSelectionModal(false);
    document.body.classList.remove("prevent-scroll");
  };

  useModalClose(MODAL_ID, closeModalWrapper);

  const updateLocation = (code) => {
    setLocationCode(code);
    navigate(`/${code}`, { replace: true });
    reloadApp();
  };

  const options = (
    locationsData?.map((location) => ({
      value: location.code,
      label: location.code
    })) ?? []
  ).sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div id={MODAL_ID} className="map-modal-wrapper">
      <div className="map-modal-container">
        <div className="site-selection-container">
          <p className="site-selection-title">Site Selection</p>
          <div className="location-selection">
            {plantCode && <p>Selected Site </p>}
            <Select
              showSearch
              placeholder="Select a plant"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="plant-search-dropdown"
              options={options}
              onChange={updateLocation}
              value={getLocationPlaceholder}
            />
          </div>
        </div>
        <div onClick={closeModalWrapper} className="close-button">
          <img src={closeBtn} alt="close button" />
        </div>
        <div className="modal-map-container">
          {locationsWithLatLng?.length ? (
            <MapContainer
              style={{
                height: "100%",
                width: "100%",
                borderRadius: "20px"
              }}
              center={[35, -100]}
              zoom={4}
              zoomControl={false}
              scrollWheelZoom={false}
              attributionControl={false}
              ref={siteSelectionMap}
              onclick={addMarker}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {locationsWithLatLng?.map((location) => (
                <Marker
                  key={location.code}
                  icon={icon({
                    iconUrl:
                      location.code === plantCode
                        ? activeLocationMarker
                        : locationMarker,
                    iconSize: [22, 32]
                  })}
                  position={location.position}
                >
                  <Tooltip direction="top" offset={[0, -10]}>
                    {location.code}
                  </Tooltip>
                  <Popup>
                    <SiteSelectionPopup location={location} />
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MapModal;
